import { useLanguage, type Language } from '../../hooks/useLanguage';

/**
 * Inline EN | NL toggle for marketing footers.
 *
 * Mono-styled to sit alongside copyright + legal links. Active language
 * is rendered in foreground colour, the other in dim — clicking either
 * sets the language (and persists via useLanguage).
 */
export default function FooterLanguageSwitch() {
  const { language, setLanguage } = useLanguage();
  const options: { code: Language; label: string }[] = [
    { code: 'en', label: 'EN' },
    { code: 'nl', label: 'NL' },
  ];
  return (
    <div
      role="group"
      aria-label="Language"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        fontFamily: 'var(--font-mono)',
        fontSize: 12,
      }}
    >
      {options.map((opt, i) => (
        <span key={opt.code} style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
          <button
            type="button"
            onClick={() => setLanguage(opt.code)}
            aria-pressed={language === opt.code}
            style={{
              background: 'transparent',
              border: 'none',
              padding: '2px 6px',
              borderRadius: 4,
              cursor: 'pointer',
              fontFamily: 'inherit',
              fontSize: 'inherit',
              letterSpacing: '0.04em',
              color: language === opt.code ? 'var(--fg)' : 'var(--fg-dim)',
              transition: 'color 150ms',
            }}
          >
            {opt.label}
          </button>
          {i < options.length - 1 && (
            <span aria-hidden style={{ color: 'var(--border-strong)' }}>·</span>
          )}
        </span>
      ))}
    </div>
  );
}
